<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-政府园区-修改
    -->
  <el-dialog
    title="修改政府企业/园区/土地"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
    
        <!-- 新增类型选择单选框 -->
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type" @change="handleTypeChange">
            <el-radio label="enterprise">企业</el-radio>
            <el-radio label="park">园区</el-radio>
            <el-radio label="land">土地</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 通用字段 - 名称 -->
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

  

        <!-- 土地类型特有字段 -->
        <div v-if="form.type === 'land'">
          <el-form-item label="亩数" prop="acreage">
            <el-input
              v-model="form.acreage"
              placeholder="请输入土地亩数"
              class="max-w460"
            >
              <template slot="append">亩</template>
            </el-input>
          </el-form-item>
          
          <el-form-item label="价格" prop="price">
            <el-input
              v-model="form.price"
              placeholder="请输入土地价格"
              class="max-w460"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          
          <el-form-item label="土地介绍">
            <div class="edit_container">
              <Uediter
                v-model="form.intro"
                :text="landUeditor.text"
                :config="landUeditor.config"
                ref="landUe"
              ></Uediter>
            </div>
          </el-form-item>
        </div>



        <!-- 园区类型特有字段 - bannar -->
        <el-form-item v-if="form.type === 'park'" label="园区bannar：" prop="bannar">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'bannar')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
        </el-form-item>

        <!-- 通用图片字段 - 所有类型都显示 -->
        <el-form-item label="图片：" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
        </el-form-item>

        <!-- 园区和企业类型显示介绍 -->
        <el-form-item v-if="form.type !== 'land'" label="介绍">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <!-- 排序 - 所有类型都显示 -->
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import ParkApi from "@/api/park.js";
import SupplyApi from '@/api/supply.js';
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter,
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        }
      },
      landUeditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 200
        }
      },
      /*form表单数据*/
      form: {
        type: "park", // 默认选择园区类型
        name: "",
        code: "custom",
        image: [],
        supply_detail_id: null,
        sort: 50,
        intro: "",
        bannar: [],
        // 土地类型字段
        acreage: '',
        price: '',
        intro: '',
        // 企业类型字段
        logo: [],
        enterprise_intro: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        acreage: [{ required: true, message: '请输入亩数', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
      },
      dialogVisible: false,
      enterprise: [],
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album",
    };
  },
  created() {
    this.getEnterpriseList();
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "park_id",'supply_id'],
  methods: {
    // 类型变化处理
    handleTypeChange(type) {
      // 可以根据需要重置某些字段
      console.log("类型变更为:", type);
    },

    getEnterpriseList() {
      SupplyApi.list({}, true)
        .then(response => {
          this.enterprise = response.data.list.data;
        })
        .catch(error => {
          console.error('获取协会列表失败:', error);
        });
    },
    
    chooseCategory() {
      this.iscategorya = true;
    },
    
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      ParkApi.detail({ park_id: self.park_id }, true)
        .then((res) => {
          self.form = res.data;
          self.form.supply_detail_id = res.data.supply_detail_id;
          
          // 设置富文本内容
          self.ueditor.text = self.form.intro || "";
          self.landUeditor.text = self.form.intro || "";
          
          self.isImg = true;
          self.loading = false;
          
          // 确保数组字段存在
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
          if (!self.form.logo) {
            self.form.logo = [];
          }
          
          // 处理logo数据格式（如果是字符串路径，转换为数组格式）
          if (typeof self.form.logo === 'string' && self.form.logo) {
            self.form.logo = [{ file_path: self.form.logo }];
          }
        })
        .catch((error) => {});
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      

      // 土地类型验证
      if (form.type === 'land') {
        if (!form.acreage) {
          self.$message({
            message: "请输入亩数",
            type: 'error'
          });
          return;
        }
        if (!form.price) {
          self.$message({
            message: "请输入价格",
            type: 'error'
          });
          return;
        }
     
      }
      
      // 园区和企业类型验证
     
        form.intro = this.$refs.ue ? this.$refs.ue.getUEContent() : '';
  
      form.park_id = self.park_id;
        form.supply_id = self.supply_id;
 
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          ParkApi.edit(form, true)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success",
              });
              self.dialogFormVisible("error");
            })
            .catch((error) => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },

   /*上传商品图片*/
returnProductImgsFunc(e) {
  if (e != null && e.length > 0) {
    let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
    let prevent = false;
    
    // 检查图片格式
    e.forEach((element) => {
      let data_array = element.file_path.split(".");
      let ext = data_array[data_array.length - 1].toLowerCase();
      if (imgExpt.includes(ext)) {
        prevent = true;
      }
    });

    if (!prevent) {
      this.$message.error("图片类型有误,请选择正确的图片格式");
      this.isProductUpload = false;
      return false;
    }

    // 根据上传类型处理图片
    switch (this.code) {
      case 'album':
        // 直接赋值而不是concat，确保响应式更新
        this.form.image = [...this.form.image, ...e];
        break;
      case 'bannar':
        this.form.bannar = [...this.form.bannar, ...e];
        break;
      case 'logo':
        // 企业logo只保留一张图片
        this.form.logo = e;
        break;
    }
    
    // 强制更新视图
    this.$forceUpdate();
  }
  
  this.isProductUpload = false;
},

/*删除商品图片*/
deleteImg(index, code) {
  switch (code) {
    case 'album':
      this.form.image.splice(index, 1);
      break;
    case 'bannar':
      this.form.bannar.splice(index, 1);
      break;
    case 'logo':
      this.form.logo = [];
      break;
  }
  // 删除后强制更新
  this.$forceUpdate();
},
  },
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.logo-container {
  display: inline-block;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/park/part/edit.vue